import { render, staticRenderFns } from "./airdropBuyRecord.vue?vue&type=template&id=3838dd40&scoped=true"
import script from "./airdropBuyRecord.vue?vue&type=script&lang=js"
export * from "./airdropBuyRecord.vue?vue&type=script&lang=js"
import style0 from "./airdropBuyRecord.vue?vue&type=style&index=0&id=3838dd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3838dd40",
  null
  
)

export default component.exports